import styled from 'styled-components';

export const Root = styled.div<{ $gridheight: number }>`
  height: ${({ $gridheight }) => ($gridheight ? $gridheight * 118 : 400)}px;
  width: 100%;
  position: relative;
  margin-top: 10px;
  .MuiPaper-root {
    height: 100% !important;
    min-height: 100% !important;
    max-height: 100% !important;
  }
`;

export const HighchartContainer = styled.div`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  border: solid 1px var(--border-chart);
  background: var(--background-chart);
  padding: 10px;
  .highcharts-tooltip span {
    z-index: 9999 !important;
  }
  .tooltip {
    padding: 2px;
    background-color: var(--background-chart-tooltip);
    opacity: 1;
    z-index: 9999 !important;
  }
  .highcharts-legend-item > .highcharts-point {
    transform: unset !important;
  }
  .highcharts-indicator-menu {
    max-width: 460px;
    right: 0px !important;
    left: unset !important;
    transform: translate(-13px, -34px);
    border-radius: 4px !important;
    overflow: hidden;
  }
  .highcharts-button-box {
    x: 2;
    y: 1;
    rx: 16;
    ry: 16;
    &:hover {
      fill: #d4e5ff !important;
    }
  }
  .highcharts-button-symbol {
    width: 3.5px !important;
    fill: #4c5e72 !important;
    stroke: transparent !important;
    pointer-events: none;
  }
  .highcharts-legend-item-hidden {
    text {
      text-decoration: none !important;
      opacity: 0.5 !important;
    }
    path {
      text-decoration: none !important;
      opacity: 0.5 !important;
    }
  }
`;
